import { PERMISSIONS } from "../constants/permissions";

const STATUS = {
  approved: "approved",
  pending: "pending",
  rejected: "rejected",
  not_required: "not_required"
};

const ACTION_KEY = {
  vm: "vm",
  l1: "l1",
  l2: "l2",
};

const isApproved = (status) => status === STATUS.approved;

/*
 * Business logic for approval flow
 *
 * First-touch approval (vm_approval_status pending) reuses the vm_approval Bouncer
 * permission for all PO sources. For FINS POs, the action is labelled "OPS" in the
 * UI (see InvoiceReview chip) but the underlying permission and column are the
 * same — see ENG-19487.
 */
function getApprovalPayload(invoice) {
  if (!invoice)
    return {
      permission: PERMISSIONS.deny,
      key: "",
      message: "No invoice data",
    };
  let {
    vm_approval_status,
    l1_approval_status,
    l2_approval_status
  } = invoice;

  if (vm_approval_status === STATUS.pending || vm_approval_status === STATUS.rejected) {
    return { permission: PERMISSIONS.vm_approval, key: ACTION_KEY.vm };
  } else if (l1_approval_status === STATUS.pending || l1_approval_status === STATUS.rejected) {
    return { permission: PERMISSIONS.l1_approval, key: ACTION_KEY.l1 };
  } else if (l2_approval_status === STATUS.pending || l2_approval_status === STATUS.rejected) {
    return { permission: PERMISSIONS.l2_approval, key: ACTION_KEY.l2 };
  }

  return {
    permission: PERMISSIONS.deny,
    key: "",
    message: "All approval done. PO is completed",
  };
}

/*
 * Business logic for rejection flow
 */
function getRejectPayload(invoice) {
  if (!invoice)
    return {
      permission: PERMISSIONS.deny,
      key: "",
      message: "No invoice data",
    };
  let {
    vm_approval_status,
    l1_approval_status,
    l2_approval_status
  } = invoice;

  if (vm_approval_status === STATUS.pending || vm_approval_status === STATUS.rejected) {
    return { permission: PERMISSIONS.vm_approval, key: ACTION_KEY.vm };
  } else if (l1_approval_status === STATUS.pending || l1_approval_status === STATUS.rejected) {
    return { permission: PERMISSIONS.l1_approval, key: ACTION_KEY.l1 };
  } else if (l2_approval_status === STATUS.pending || l2_approval_status === STATUS.rejected) {
    return { permission: PERMISSIONS.l2_approval, key: ACTION_KEY.l2 };
  }

  return {
    permission: PERMISSIONS.deny,
    key: "",
    message: "PO is in complete status. No rejection allowed",
  };
}

export { getApprovalPayload, getRejectPayload };
